import auth from '@/router/auth'
import HomeIndex from '@/components/home/Index'

export default [
  {
    path: '/',
    name: 'home-index',
    component: HomeIndex,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/home/router.js